<div class="row">
  <div class="col s12">
    <h4 class="h4 chart-title chart-title--thin margin-none padding-top_half">
      {{ 'groups.dashboard.recentActivity' | translate }}
      <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
    </h4>
  </div>
</div>
<div class="row flex">
  <div class="col s4 border-right-grey">
    <lms-active-students-widget
      [totals]="totalsStudents"
      [data]="data"
      [key]="'activeStudents'"
    ></lms-active-students-widget>
  </div>

  <div class="col s4 border-right-grey">
    <lms-amount-widget [quantity]="activeStudentsActivity?.total" [units]="connectedUnits" [showZeroQuantity]="true">
      <div title>
        <div class="chart-subtitle">
          {{ 'groups.dashboard.connected' | translate }}
          <gl-tooltip posBottom [text]="secondaryTooltipText"></gl-tooltip>
        </div>
      </div>
    </lms-amount-widget>
  </div>

  <div class="col s4">
    <lms-amount-widget
      [quantity]="activeStudentsActivity?.averageDuration / 60 / 60"
      [units]="averageDurationUnits"
      [showZeroQuantity]="true"
    >
      <div title>
        <div class="chart-subtitle">
          {{ 'groups.dashboard.averageDuration' | translate }}
          <gl-tooltip posBottom [text]="tertiaryTooltipText"></gl-tooltip>
        </div>
      </div>
    </lms-amount-widget>
  </div>
</div>
